module.exports = __webpack_public_path__ + "static/media/faq_icon.530e923c.svg";